import { Tabs, Text } from '@innovationdepartment/proxima-ui';
import SectionLayout from 'ui/SectionLayout';
import BrandWorkflowsManualTriggersList from './BrandWorkflows.ManualTriggersList';
import { HeaderRow, TabsWrapper } from './BrandWorkflows.styles';
import type { BrandWorkflowRow, BrandWorkflowTab, KickOffError } from './BrandWorkflows.types';
import { BRAND_WORKFLOW_TABS } from './BrandWorkflows.types';
import WorkflowExecutionList from './WorkflowExecutionList';
import { formatWorkflowTimestamp } from './workflowFormatters';

const tabs = [
  { label: 'Latest', key: BRAND_WORKFLOW_TABS.Latest },
  { label: 'Manual Triggers', key: BRAND_WORKFLOW_TABS.ManualTriggers }
];

type BrandWorkflowsViewProps = {
  rows: BrandWorkflowRow[];
  lastUpdatedAt: Date | null;
  activeTab: BrandWorkflowTab;
  retryingExecutionId: string | null;
  expandedWorkflowType: string | null;
  kickingOffWorkflowType: string | null;
  kickOffError: KickOffError | null;
  onTabChange: (tab: BrandWorkflowTab) => void;
  onRetryFromFailed: (executionId: string) => void;
  onToggleManualTrigger: (workflowType: string) => void;
  onKickOff: (workflowType: string, payloadText: string) => void;
};

const BrandWorkflowsView = ({
  rows,
  lastUpdatedAt,
  activeTab,
  retryingExecutionId,
  expandedWorkflowType,
  kickingOffWorkflowType,
  kickOffError,
  onTabChange,
  onRetryFromFailed,
  onToggleManualTrigger,
  onKickOff
}: BrandWorkflowsViewProps) => (
  <SectionLayout
    title="Workflows"
    headerContent={
      <HeaderRow>
        <TabsWrapper>
          <Tabs
            tabs={tabs}
            tab={activeTab}
            onChange={(tabKey: string) => onTabChange(tabKey as BrandWorkflowTab)}
          />
        </TabsWrapper>
        {lastUpdatedAt ? (
          <Text variant="body2" color="neutral50">
            Updated {formatWorkflowTimestamp(lastUpdatedAt)}
          </Text>
        ) : null}
      </HeaderRow>
    }
  >
    {activeTab === BRAND_WORKFLOW_TABS.Latest && (
      <WorkflowExecutionList
        rows={rows}
        emptyText="No workflows have run for this brand yet."
        showRetry
        showRunHistoryLink
        retryingExecutionId={retryingExecutionId}
        onRetryFromFailed={onRetryFromFailed}
      />
    )}
    {activeTab === BRAND_WORKFLOW_TABS.ManualTriggers && (
      <BrandWorkflowsManualTriggersList
        rows={rows}
        expandedWorkflowType={expandedWorkflowType}
        kickingOffWorkflowType={kickingOffWorkflowType}
        kickOffError={kickOffError}
        onToggleExpand={onToggleManualTrigger}
        onKickOff={onKickOff}
      />
    )}
  </SectionLayout>
);

export default BrandWorkflowsView;
